<template>
  <div class="v-view table-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <table class="tv-table">
      <thead class="tv-table-head" align="center">
        <tr>
          <th v-for="(item, index) in tableHead" :key="index">
            {{ item }}
          </th>
        </tr>
      </thead>

      <tbody v-if="tableList.length > 0" class="tv-table-body" align="center">
        <tr v-for="item in tableList" :key="item.id">
          <!-- <td v-for="(value, key) in item" :key="key">{{ value }}</td> -->
          <td class="td-name">{{ item.name }}</td>
          <td>{{ item.year }}</td>
          <td>{{ item.month }}</td>
          <td>{{ item.day }}</td>
        </tr>
      </tbody>
      <tbody v-else class="tv-table-nodata">
        <tr>
          <td colspan="5">暂无数据!</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { numToThousands } from '@/utils';

export default {
  name: 'ServiceData',
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '养老服务统计',
    },
  },
  watch: {
    tableData(newData, oldData) {
      const newItem = newData.length && newData[0]
      const oldItem = oldData.length && oldData[0]
      if (!oldItem || newItem.CurrentYear !== oldItem.CurrentYear) {
        const servesConfiguration = this.$configer.servesConfiguration
        const serves = this.$configer.serves
        // this.tableList = newData.map((item) => ({
        //   id: item.OrderBy,
        //   name: item.Item,
        //   year: numToThousands(item.CurrentYear),
        //   month: numToThousands(item.CurrentMonth),
        //   day: numToThousands(item.CurrentDay),
        // }))
        let array = []
        for (let index = 0; index < serves.length; index++) {
          const element = serves[index];
          for (let ind = 0; ind < newData.length; ind++) {
            const item = newData[ind];
            if (item.Item == element.Item) {
              array.push(
                {
                  id: item.OrderBy,
                  name: item.Item,
                  year: numToThousands(item.CurrentYear + element.CurrentYear),
                  month: numToThousands(item.CurrentMonth + element.CurrentMonth),
                  day: numToThousands(item.CurrentDay + element.CurrentDay),
                }
              )
            }
          }
      }
      this.tableList = array
    }
    }
  },
  data() {
    return {
      dataInterval: null,
      tableHead: ['项目', '当年', '当月', '当日'],
      tableData: [],
      tableList: [],
    }
  },
  created() {
    this.getServiceData(this.cid)
  },
  mounted() {
    this.dataInterval = setInterval(() => {
      this.getServiceData(this.cid)
    }, this.$interval)
  },
  beforeDestroy() {
    if (this.dataInterval) {
      clearInterval(this.dataInterval)
      this.dataInterval = null
    }
  },
  methods: {
    getServiceData(cid) {
      this.$api
        .getServiceData(cid)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return
          this.tableData = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>
